import React from 'react';
export function useKeyboardReorder({ onChangeTabs, tabs, selectedTabPath }, rootRef) {
    const [showKeyboardTooltip, setShowKeyboardTooltip] = React.useState(false);
    const handleKeyDown = React.useCallback((event) => {
        const index = tabs.findIndex((tab) => tab.path === selectedTabPath);
        if (index !== -1 && onChangeTabs) {
            const focusActiveTab = () => {
                window.setTimeout(() => {
                    var _a, _b;
                    if (selectedTabPath) {
                        (_b = (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`button[data-tab-path="${selectedTabPath}"]`)) === null || _b === void 0 ? void 0 : _b.focus();
                    }
                }, 0);
            };
            switch (event.key) {
                case '[':
                    if (index > 0) {
                        onChangeTabs([...tabs.slice(0, index - 1), tabs[index], tabs[index - 1], ...tabs.slice(index + 1)]);
                        focusActiveTab();
                    }
                    break;
                case ']':
                    if (index < tabs.length - 1) {
                        onChangeTabs([...tabs.slice(0, index), tabs[index + 1], tabs[index], ...tabs.slice(index + 2)]);
                        focusActiveTab();
                    }
                    break;
            }
        }
    }, [onChangeTabs, tabs, selectedTabPath, rootRef]);
    return { showKeyboardTooltip, setShowKeyboardTooltip, handleKeyDown };
}
